import { useMemo } from "react"
import { buildSeoJsonLd } from "../lib/siteSeo"

export default function SeoJsonLd() {
    const json = useMemo(() => JSON.stringify(buildSeoJsonLd()), [])
    return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: json }} />
}
